export default "__VITE_ASSET__Dvz03w$j__"